import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Checkbox} from "primereact/checkbox";

const EventtypestatusFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [recruitmentEventType, setRecruitmentEventType] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      name: formData.name || '',
      date_required: !!formData.date_required,
      note_required: !!formData.note_required,
      rating_required: !!formData.rating_required,
      is_dropout: !!formData.is_dropout,
      recruitmentEventType:
        formData.recruitmentEventType ||
        formData.recruitment_event_type?.id ||
        formData.recruitment_event_type
    };
    if ((window.App.urlVars().eventtypestatusId) || (entity === 'event-type-status' && id)) {
      apiCall('patch', '/api/v2/recruitment-event-type-status/' + (window.App.urlVars().eventtypestatusId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEventtypestatusList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/recruitment-event-type-status', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEventtypestatusList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/recruitment/event-type-status/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/recruitment-event-type', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setRecruitmentEventType(response.data.data.items || [])
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
  }, [])

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().eventtypestatusId) || (entity === 'event-type-status' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/recruitment-event-type-status/' + (window.App.urlVars().eventtypestatusId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"event-type-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="recruitmentEventType" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="recruitmentEventType">{props.t('fieldRecruitmentEventType')}</label>

                  <Dropdown
                    id="recruitmentEventType"
                    value={
                      formData.recruitment_event_type?.id ||
                      formData.recruitmentEventType ||
                      formData.recruitment_event_type ||
                      null
                    }
                    options={window.App.sortDropdownOptions(recruitmentEventType, "name")}
                    optionLabel="name"
                    optionValue="id"
                    placeholder={t('selectEventTypePlaceholder')}appendTo={document.body}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        recruitmentEventType: e.value,
                        recruitment_event_type: e.value
                      });

                      setNewFormData({
                        ...newFormData,
                        recruitmentEventType: e.value
                      });
                    }}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            
              
            <div className={"p-col-12 p-lg-3"}>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="date_required" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="date_required"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldDateRequired')}</label>
                    <span className="p-d-block">
                      <Checkbox
                        inputId="date_required"
                        className="p-mt-1"
                        checked={!!formData.date_required}
                        onChange={(e) => setFormData({...formData, date_required: e.checked})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>


            <div className={"p-col-12 p-lg-3"}>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="note_required" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="note_required"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldNoteRequired')}</label>
                    <span className="p-d-block">
                      <Checkbox
                        inputId="note_required"
                        className="p-mt-1"
                        checked={!!formData.note_required}
                        onChange={(e) => setFormData({...formData, note_required: e.checked})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>


            <div className={"p-col-12 p-lg-3"}>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="rating_required" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="rating_required"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldRatingRequired')}</label>
                    <span className="p-d-block">
                      <Checkbox
                        inputId="rating_required"
                        className="p-mt-1"
                        checked={!!formData.rating_required}
                        onChange={(e) => setFormData({...formData, rating_required: e.checked})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>



            <div className={"p-col-12 p-lg-3"}>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="is_dropout" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="is_dropout"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldIsDropout')}</label>
                    <span className="p-d-block">
                      <Checkbox
                        inputId="is_dropout"
                        className="p-mt-1"
                        checked={!!formData.is_dropout}
                        onChange={(e) => setFormData({...formData, is_dropout: e.checked})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'event-type-status' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EventtypestatusFormComponent);
